import { render } from "./birthday-import-modal.vue?vue&type=template&id=408366a1"
import script from "./birthday-import-modal.vue?vue&type=script&lang=js"
export * from "./birthday-import-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__